import { TranslationMap } from '@trimble-gcs/i18n-types';

export function classificationTranslations() {
  return {
    reset: {
      text: $localize`:@@config.classifications.reset:Revert to Default`,
      desc: 'Button text to reset classifications to default.',
    },
    resetConfirmation: {
      title: {
        text: $localize`:@@config.classifications.resetConfirmation.title:Reset Classifications`,
        desc: 'Title for the reset classifications confirmation dialog.',
      },
      message: {
        text: $localize`:@@config.classifications.resetConfirmation.message:Are you sure you want to reset classifications to the default?`,
        desc: 'Message for the reset classifications confirmation dialog.',
      },
      confirm: {
        text: $localize`:@@config.classifications.resetConfirmation.confirm:Reset`,
        desc: 'Text for the button to confirm resetting classifications to default.',
      },
    },
    export: {
      text: $localize`:@@config.classifications.export:Export`,
      desc: 'Button text to download classifications to local JSON file.',
    },
    import: {
      text: $localize`:@@config.classifications.import:Import`,
      desc: 'Button text to import classifications from local JSON file.',
    },
    importConfirmation: {
      title: {
        text: $localize`:@@config.classifications.importConfirmation.title:Import Classifications`,
        desc: 'Title for the import classifications confirmation dialog.',
      },
      messages: {
        '=1': {
          text: $localize`:@@config.classifications.importConfirmation.messageOne:Are you sure you want to import 1 classification?`,
          desc: 'Message for the import classifications when importing one classification.',
        },
        other: {
          text: $localize`:@@config.classifications.importConfirmation.messageOther:Are you sure you want to import {count} classifications?`,
          desc: 'Message for the import classifications when importing multiple classifications.',
        },
      },
      confirm: {
        text: $localize`:@@config.classifications.importConfirmation.confirm:Import`,
        desc: 'Text for the button to confirm importing classifications from local JSON file.',
      },
    },
    save: {
      text: $localize`:@@config.classifications.save:Save`,
      desc: 'Button text to save classifications.',
    },
    cancel: {
      text: $localize`:@@config.classifications.cancel:Cancel`,
      desc: 'Button text to discard changes to classifications.',
    },
    errors: {
      load: {
        text: $localize`:@@config.classifications.errors.load:Error loading classifications.`,
        desc: 'Error message shown when classifications fail to load.',
      },
      save: {
        text: $localize`:@@config.classifications.errors.save:Error saving classifications.`,
        desc: 'Error message shown when classifications fail to save.',
      },
      reset: {
        text: $localize`:@@config.classifications.errors.reset:Error resetting classifications.`,
        desc: 'Error message shown when classifications fail to reset.',
      },
      import: {
        text: $localize`:@@config.classifications.errors.import:Error importing classifications.`,
        desc: 'Error message shown when classifications fail to import.',
      },
    },
  } satisfies TranslationMap;
}
